import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import map from 'lodash/map';
import includes from 'lodash/includes';
import isEqual from 'lodash/isEqual';
import filter from 'lodash/filter';
import get from 'lodash/get';

import Label from '../Label';
import { useControlledInputs } from '../../common/hooks';
import Item from '../Item';

const mapDefaultToValue = (v, { options, multi, showAll }) => {
  if (v !== undefined) return v;

  if (multi) {
    return [];
  }

  return showAll ? '' : get(options[0], 'value');
};
const mapValuetoValue = v => v;
/**
 * 标签选择控件
 */
export default function LabelSelect({
  defaultValue,
  onChange,
  options,
  multi,
  mini,
  disabled,
  showAll,
  className,
  style
}) {
  const { value, handleChange } = useControlledInputs({
    defaultValue,
    onChange,
    mapDefaultToValue,
    mapValuetoValue,
    props: {
      options,
      multi,
      showAll
    }
  });
  const isAllSelected = value => {
    if (multi) {
      return !value.length || value.length === options.length;
    }

    return value === undefined || value === '';
  };
  const isItemSelected = item => {
    if (multi) return includes(value, item.value);

    return isEqual(value, item.value);
  };

  const getLabelType = active => (active ? 'info' : '');

  const selectAll = useCallback(() => {
    if (disabled) return;
    handleChange(multi ? [] : '');
  }, [disabled, handleChange, multi]);

  const handleSelectChange = item => {
    if (disabled) return;
    if (multi) {
      const active = includes(value, item.value);
      let result = active
        ? filter(value, v => !isEqual(v, item.value))
        : [...value, item.value];

      handleChange(result);
    } else {
      handleChange(item.value);
    }
  };

  const classes = classNames(
    {
      'label-select': true,
      disabled,
      mini
    },
    className
  );

  return (
    <div className={classes} style={style}>
      <Item show={showAll}>
        <Label
          className="label-select-item"
          onClick={selectAll}
          key="all"
          type={getLabelType(isAllSelected(value))}
        >
          全部
        </Label>
      </Item>
      {map(options, item => {
        const active = isItemSelected(item);

        return (
          <Label
            key={item.value}
            type={getLabelType(active)}
            closable={active && multi}
            onClick={() => handleSelectChange(item, active)}
            className="label-select-item"
          >
            {item.label}
          </Label>
        );
      })}
    </div>
  );
}
LabelSelect.defaultProps = {
  showAll: true,
  multi: false,
  locale: 'zh_CN'
};
LabelSelect.propTypes = {
  /** 值改变时的回调 */
  onChange: PropTypes.func,
  /** 选项列表, 遵循各种选项的格式 { value, label } */
  options: PropTypes.array,
  /** 是否多选 */
  multi: PropTypes.bool,
  /** 是否自动展示 “全部” 标签 */
  showAll: PropTypes.bool,
  /** 国际化 */
  locale: PropTypes.string
};
